// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"06ae7f01","835":"8956793d"}[chunkId] + ".css";
};